export const MAX_MONITOR_CONDITION_LENGTH = 500;
